var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatXlsx = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10701_3157)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_10701_3157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79976C5.14879 32 2.99976 29.851 2.99976 27.2V4.8C2.99976 2.14903 5.14879 0 7.79976 0H16.4708C17.7309 0 18.9406 0.495552 19.8385 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8507 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79976C5.48016 31.4 3.59976 29.5196 3.59976 27.2V4.8C3.59976 2.4804 5.48016 0.6 7.79976 0.6H16.4708C17.5734 0.6 18.6318 1.03361 19.4175 1.80722L27.1465 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10701_3157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_10701_3157",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H25.3562C27.0131 14 28.3562 15.3431 28.3562 17V25C28.3562 26.6569 27.0131 28 25.3562 28H3C1.34314 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H25.3562C27.0131 14 28.3562 15.3431 28.3562 17V25C28.3562 26.6569 27.0131 28 25.3562 28H3C1.34314 28 0 26.6569 0 25V17Z",
    fill: "#1F8957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H25.3562C27.4549 13.2 29.1562 14.9013 29.1562 17H27.5562C27.5562 15.785 26.5713 14.8 25.3562 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM28.3562 28H0H28.3562ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM25.3562 13.2C27.4549 13.2 29.1562 14.9013 29.1562 17V24.2C29.1562 26.2987 27.4549 28 25.3562 28C26.5713 28 27.5562 26.6569 27.5562 25V17C27.5562 15.785 26.5713 14.8 25.3562 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_10701_3157)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35313 17.7953L5.7625 20.139H5.8125L7.22813 17.7953H8.55L6.57812 20.9953L8.58125 24.1953H7.2375L5.8125 21.8671H5.7625L4.3375 24.1953H3L5.02188 20.9953L3.025 17.7953H4.35313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46016 24.1953V17.7953H10.6195V23.2234H13.4383V24.1953H9.46016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9227 19.5546C17.8935 19.2817 17.7706 19.0692 17.5539 18.9171C17.3393 18.7651 17.0602 18.689 16.7164 18.689C16.4747 18.689 16.2674 18.7255 16.0945 18.7984C15.9216 18.8713 15.7893 18.9703 15.6977 19.0953C15.606 19.2203 15.5591 19.363 15.557 19.5234C15.557 19.6567 15.5872 19.7723 15.6477 19.8703C15.7102 19.9682 15.7945 20.0515 15.9008 20.1203C16.007 20.1869 16.1247 20.2432 16.2539 20.289C16.3831 20.3348 16.5133 20.3734 16.6445 20.4046L17.2445 20.5546C17.4862 20.6109 17.7185 20.6869 17.9414 20.7828C18.1664 20.8786 18.3674 20.9994 18.5445 21.1453C18.7237 21.2911 18.8654 21.4671 18.9695 21.6734C19.0737 21.8796 19.1258 22.1213 19.1258 22.3984C19.1258 22.7734 19.0299 23.1036 18.8383 23.389C18.6466 23.6723 18.3695 23.8942 18.007 24.0546C17.6466 24.213 17.2102 24.2921 16.6977 24.2921C16.1997 24.2921 15.7674 24.2151 15.4008 24.0609C15.0362 23.9067 14.7508 23.6817 14.5445 23.3859C14.3404 23.0901 14.2299 22.7296 14.2133 22.3046H15.3539C15.3706 22.5276 15.4393 22.713 15.5602 22.8609C15.681 23.0088 15.8383 23.1192 16.032 23.1921C16.2279 23.2651 16.4466 23.3015 16.6883 23.3015C16.9404 23.3015 17.1612 23.264 17.3508 23.189C17.5424 23.1119 17.6924 23.0057 17.8008 22.8703C17.9091 22.7328 17.9643 22.5723 17.9664 22.389C17.9643 22.2223 17.9154 22.0848 17.8195 21.9765C17.7237 21.8661 17.5893 21.7744 17.4164 21.7015C17.2456 21.6265 17.0456 21.5598 16.8164 21.5015L16.0883 21.314C15.5612 21.1786 15.1445 20.9734 14.8383 20.6984C14.5341 20.4213 14.382 20.0536 14.382 19.5953C14.382 19.2182 14.4841 18.888 14.6883 18.6046C14.8945 18.3213 15.1747 18.1015 15.5289 17.9453C15.8831 17.7869 16.2841 17.7078 16.732 17.7078C17.1862 17.7078 17.5841 17.7869 17.9258 17.9453C18.2695 18.1015 18.5393 18.3192 18.7352 18.5984C18.931 18.8755 19.032 19.1942 19.0383 19.5546H17.9227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1281 17.7953L22.5375 20.139H22.5875L24.0031 17.7953H25.325L23.3531 20.9953L25.3562 24.1953H24.0125L22.5875 21.8671H22.5375L21.1125 24.1953H19.775L21.7969 20.9953L19.8 17.7953H21.1281Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10701_3157",
    x: 1.39976,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10701_3157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10701_3157",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10701_3157"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10701_3157",
    x: 0,
    y: 14,
    width: 28.3562,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10701_3157"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10701_3157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatXlsx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatXlsx.83f7abcd68927cd63b0300f34af17f20.svg";